<div class="container-fluid pt-4 h-100">
  <div class="pre-processing-container h-100 d-flex flex-column">
    <div class="header d-flex justify-content-center flex-column">
      <span class="header-5"> Model Execution</span>
    </div>
    <div class="card-body">
      <div class="d-flex justify-content-end align-items-center my-2">
        <span class="w-100 accello-general-text12">Select the items you want to remove from the list using the checkboxes.</span>
        <div class="w-100 d-flex justify-content-end">
        <button class="btn-accello-ternary btn-accello" (click)="openDeleteConfirmation()"
        [disabled]="isRemoveModelDisabled"
        >
          <img
            src="assets/images/virtusa-icons/remove-icon-dark.svg"
            alt="Remove Icon"
          />
          Remove Model
        </button>
        </div>
      </div>
      <div *ngIf="records && !isLoading" class="col-md-12 segmentation">
        <app-zorro-table
          tableId="model-execs"
          [columns]="records?.columns"
          [data]="records?.rows"
          (onRowSelect)="handleRowSelection($event)"
          class="w-100"
        ></app-zorro-table>
      </div>
      <div
        *ngIf="isLoading"
        class="loader-content d-flex flex-column justify-content-center"
      >
        <app-loading [text]="'Loading...'"></app-loading>
      </div>
    </div>
    <div class="footer d-flex justify-content-end">
      <button class="btn-accello-primary-outlined align-items-center mx-2" (click)="goBack()">Back</button>
      <button
        class="btn btn-accello-primary mx-2 btn-spin"
        (click)="navigateToResults()"
        [disabled]="isDisabled"
      >
      <span>Next</span>
        @if(isProcessing){
          <span class="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
          }
      </button>
    </div>
  </div>
</div>
